<div class="custom-dropdown" [class.open]="isOpen" [class.disabled]="disabled">

  <!-- Selected Items Display -->
  <div class="dropdown-header" (click)="toggleDropdown()">
    <div class="selected-items">
      <ng-container *ngIf="selectedItems.length === 0">
        <span class="placeholder">{{ placeholder }}</span>
      </ng-container>
      <ng-container *ngIf="selectedItems.length > 0">
        <div class="selected-badges">
          <div class="badge" *ngFor="let item of selectedItems | slice:0:itemsShowLimit">
            {{ getDisplayValue(item) }}
            <span class="remove-btn" (click)="removeItem($event, item)">×</span>
          </div>
          <div class="badge more" *ngIf="selectedItems.length > itemsShowLimit">
            +{{ selectedItems.length - itemsShowLimit }}
          </div>
        </div>
      </ng-container>
    </div>
    <div class="dropdown-arrow">
      <svg *ngIf="!isOpen" width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <svg *ngIf="isOpen" width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M17 14L12 9L7 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </div>
  </div>

  <!-- Dropdown List -->
  <div class="dropdown-list" *ngIf="isOpen">

    <!-- Search Input -->
    <div class="search-container" *ngIf="showSearch">
      <input
        type="text"
        class="search-input"
        [placeholder]="searchPlaceholder"
        [(ngModel)]="searchTerm"
        (input)="onSearchInput()"
      />
      <div class="search-loading" *ngIf="isLoading">
        <div class="spinner"></div>
      </div>
    </div>

    <!-- Options Container with Scroll -->
    <div class="options-container"
         [style.maxHeight.px]="maxHeight"
         (scroll)="onScroll($event)">

      <!-- Options List -->
      <div
        class="option"
        *ngFor="let item of data"
        (click)="toggleItem(item)"
        [class.selected]="isSelected(item)">

        <div class="checkbox" *ngIf="multiSelect">
          <svg *ngIf="isSelected(item)" width="12" height="12" viewBox="0 0 24 24" fill="none">
            <path d="M20 6L9 17L4 12" stroke="white" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="radio" *ngIf="!multiSelect">
          <div class="radio-inner" *ngIf="isSelected(item)"></div>
        </div>
        <span class="option-text">{{ getDisplayValue(item) }}</span>
      </div>

      <!-- No Results -->
      <div class="no-results" *ngIf="data.length === 0 && !isLoading">
        {{ noResultsText }}
      </div>

      <!-- Loading Indicator -->
      <div class="loading-more" *ngIf="isLoadingMore">
        <div class="spinner small"></div>
        Loading more...
      </div>
    </div>
  </div>
</div>
